module.exports = __webpack_public_path__ + "assets/8e41b5bb299e3456f8eb3c94547eca62.svg";